import { IAppInfo } from "@calaosoft/osapp-common/applications/models/IAppInfo";
import { EAuthenticationAction } from "@calaosoft/osapp-common/authentication/models/EAuthenticationAction";
import { IAuthentication } from "@calaosoft/osapp-common/authentication/models/IAuthentication";
import { IBackgroundTask } from "@calaosoft/osapp-common/background-tasks/models/ibackground-task";
import { Credentials } from "@calaosoft/osapp-common/security/models/credentials";
import { ISecurityConfig } from "@calaosoft/osapp-common/security/models/ISecurityConfig";
import { EUpdateProvider } from "@calaosoft/osapp-common/update/models/EUpdateProvider";
import { IUpdateConfig } from "@calaosoft/osapp-common/update/models/IUpdateConfig";
import { EFormEngine } from "@calaosoft/osapp-mobile/model/forms/EFormEngine";
import { TaskService } from "@calaosoft/osapp-mobile/modules/logistics/task/services/task.service";
import { C_ADMINISTRATORS_ROLE_ID } from "@calaosoft/osapp-mobile/modules/permissions/services/permissions.service";
import { AppointmentService } from "@calaosoft/osapp-mobile/modules/tour/appointment/appointment.service";
import { PatternSettings } from "@calaosoft/osapp-mobile/services/pattern-resolver.service";
import { APP_CORE_DATABASE_PREFIX, APP_ID, environment } from "./environments/environment";

export * from "./environments/environment";

PatternSettings.imports = {
	...PatternSettings.imports,
	AppointmentService: AppointmentService,
	TaskService: TaskService
};

const defaultHearbeatIntervalMilliseconds = 60000;

export const appInfo: IAppInfo = {
	appId: APP_ID,
	formEngine: EFormEngine.formly,
	deviceId: "123",
	appName: "MerchApp",
	supportEmail: "support@calaosoft.fr",
	firstName: "",
	lastName: "",
	login: "",
	applicationDatabaseId: `${APP_CORE_DATABASE_PREFIX}local_application_storage`,
	useLinks: true,
	unlockRequired: environment.unlockRequired,
	coreDatabasePrefix: APP_CORE_DATABASE_PREFIX,
	changelogsUrl: "https://install.mobile.calaosoft.fr/public/merchapp/changelog.html"
};

export const authentication: IAuthentication = {
	type: "disable",
	hearbeatIntervalMilliseconds: defaultHearbeatIntervalMilliseconds,
	appCredentials: environment.appCredentials!,
	credentials: Credentials.createDefault(),
	authenticatorParams: {
		_id: "",
		loginEditEnabled: true,
		newAccountEnabled: false,
		passwordForgottenEnabled: false,
		authenticationAction: EAuthenticationAction.route,
		imgEnabled: true,
		backgroundStyles: "auth",
		login: "",
		password: "",
		thumbnailPicture: environment.thumbnailLogo,
		thumbnailIcon: environment.thumbnailLogo,
		pinEnabled: true,
		initUserContactAfterAuth: false,
		destinationPathAfterAuth: "home"
	}
};

export const update: IUpdateConfig = {
	android: {
		updateCheckIntervalMinutes: 30,
		updateProvider: EUpdateProvider.calaoStore,
		updatesApiUrl: `${environment.cloud_url}${environment.cloud_api_apps_suffix}updates`
	},
	ios: {
		updateCheckIntervalMinutes: 30,
		updateProvider: EUpdateProvider.calaoStore,
		updatesApiUrl: `${environment.cloud_url}${environment.cloud_api_apps_suffix}updates`
	}
};

export const backgroundTask: IBackgroundTask = {
	execTasksIntervalMs: 30000
};

export const security: ISecurityConfig = {
	builtInRoles: {
		administrators: {
			id: C_ADMINISTRATORS_ROLE_ID,
			label: "Administrateur"
		}
	},
	permissions: {
		default: {
			contacts: {
				create: true,
				edit: true,
				delete: false,
				read: true
			},
			customerContact: {
				create: true,
				edit: true,
				delete: false,
				read: true
			},
			conversations: {
				create: true,
				edit: true,
				delete: false,
				read: true
			}
		},
		[C_ADMINISTRATORS_ROLE_ID]: {
			contacts: {
				create: true,
				edit: true,
				delete: true,
				read: true
			},
			conversations: {
				create: true,
				edit: true,
				delete: true,
				read: true
			}
		}
	}
};

export const disableLinks = true;

export const builtInEntityDescIds: string[] = ["customer", "task", "customerContact"];
